import axios from "axios";
import cookies from "vue-cookies";
import router from '../../../router/router' 

axios.defaults.baseURL = `${window.runtimeConfig?.VITE_APP_API}/api`;
axios.defaults.headers.common["accept-language"] = "th";

let _loaderRef = null;
export function registerLoaderRef(vueRef) {
  _loaderRef = vueRef;
}

// ====== loader state ======
let active = 0;
let hideTimer = null;
let lastShownAt = 0;

const HIDE_DELAY_MS = 600;
const MIN_SHOW_MS = 400;

// ====== helper ทำงานจริง ======
function showNow() {
  clearTimeout(hideTimer);
  lastShownAt = Date.now();
  try {
    _loaderRef.value.showLoader?.();
  } catch (e) {
    console.warn("[loader] showLoader() error:", e);
  }
}
function hideNow() {
  clearTimeout(hideTimer);
  try {
    _loaderRef.value.hideLoader?.();
  } catch (e) {
    console.warn("[loader] hideLoader() error:", e);
  }
}
function scheduleHide() {
  const elapsed = Date.now() - lastShownAt;
  const wait = Math.max(MIN_SHOW_MS - elapsed, 0) + HIDE_DELAY_MS;
  clearTimeout(hideTimer);
  hideTimer = setTimeout(() => hideNow(), wait);
}
function inc() {
  active += 1;
  if (active === 1) showNow();
}
function dec() {
  if (active > 0) active -= 1;
  if (active === 0) scheduleHide();
}

// 👉 flag ภายใน config เพื่อรู้ว่า request นี้ใช้ loader หรือไม่
const LOADER_FLAG = Symbol("useGlobalLoader");

function isTrueLike(v) {
  if (v === true) return true;
  if (typeof v === "string") {
    const s = v.trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes" || s === "on";
  }
  return false;
}
function wantsNoLoader(config) {
  const cfg = config || {};
  const headers = cfg.headers || {};
  const headerRaw =
    headers["X-No-Loader"] ?? headers["x-no-loader"] ?? headers["X-no-loader"];
  return (
    isTrueLike(cfg.noLoader) ||
    isTrueLike(cfg?.meta?.noLoader) ||
    isTrueLike(headerRaw)
  );
}

// ====== กัน interceptors ผูกซ้ำใน dev/HMR ======
if (!axios.__loaderInterceptorsAdded) {
  axios.__loaderInterceptorsAdded = true;

  axios.interceptors.request.use(
    (config) => {
      // ใส่ token
      const token = cookies.get("token");
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      } else if (config.headers && "Authorization" in config.headers) {
        delete config.headers.Authorization;
      }

      // ตัดสินใจใช้ loader
      const useLoader = !wantsNoLoader(config);

      // ลบ header คุม loader ออกจาก request จริง
      if (config.headers) {
        delete config.headers["X-No-Loader"];
        delete config.headers["x-no-loader"];
        delete config.headers["X-no-loader"];
      }

      // เก็บ flag ไว้
      config[LOADER_FLAG] = useLoader;

      if (useLoader) inc();
      return config;
    },
    (error) => {
      console.log("[axios][request][error]", error?.message);
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      if (response?.config?.[LOADER_FLAG]) dec();
      return response;
    },
    (error) => {
      if (error?.config?.[LOADER_FLAG]) dec();

      if (error?.response?.status === 401) {
        cookies.remove("token");
        // window.location.replace(`${window.location.hostname}/login`);
        router.replace('/login');
      }
      return Promise.reject(error);
    }
  );
}

export default axios;
